export const hadithTranslations = [
  {
    ar: {
      reference: "قال رسول الله صلى الله عليه وسلم:",
      text: "من علمَ آيةً من كتابِ اللهِ عز وجل كانَ لهُ ثوابُها ما تليتْ"
    },
    fr: {
      reference: "Le Messager d'Allah ﷺ a dit :",
      text: "« Celui qui enseigne une seule verset du Livre d'Allah, exalté soit-Il, obtiendra la récompense de ce verset chaque fois qu'il sera récité. »"
    },
    en: {
      reference: "The Messenger of Allah ﷺ said:",
      text: "\"Whoever teaches one verse from the Book of Allah, the Almighty, will receive its reward every time it is recited.\""
    }
  },
  {
    ar: {
      reference: "قال رسول الله صلى الله عليه وسلم:",
      text: "خيركم من تعلم القرآن وعلمه"
    },
    fr: {
      reference: "Le Messager d'Allah ﷺ a dit :",
      text: "« Le meilleur d'entre vous est celui qui apprend le Coran et l'enseigne. »"
    },
    en: {
      reference: "The Messenger of Allah ﷺ said:",
      text: "\"The best among you are those who learn the Quran and teach it.\""
    }
  },
  {
    ar: {
      reference: "قال رسول الله صلى الله عليه وسلم:",
      text: "يقال لصاحب القرآن: إقرأ وارتق ورتل كما كنت ترتل في الدنيا فإن منزلتك عند آخر آية تقرؤها"
    },
    fr: {
      reference: "Le Messager d'Allah ﷺ a dit :",
      text: "« Il sera dit au récitateur du Coran : « Lis et monte, récite comme tu récitais dans le monde d'ici-bas. Ta demeure sera au niveau du dernier verset que tu récites. »"
    },
    en: {
      reference: "The Messenger of Allah ﷺ said:",
      text: "\"It will be said to the reciter of the Quran: 'Read and rise, recite as you recited in the world. Your abode will be at the level of the last verse you recite.'\""
    }
  },
  {
    ar: {
      reference: "قال رسول الله صلى الله عليه وسلم:",
      text: "من علمَ آيةً من كتابِ اللهِ عز وجل كانَ لهُ ثوابُها ما تليتْ"
    },
    fr: {
      reference: "Le Messager d'Allah ﷺ a dit :",
      text: "« Celui qui enseigne une seule verset du Livre d'Allah, exalté soit-Il, obtiendra la récompense de ce verset chaque fois qu'il sera récité. »"
    },
    en: {
      reference: "The Messenger of Allah ﷺ said:",
      text: "\"Whoever teaches one verse from the Book of Allah, the Almighty, will receive its reward every time it is recited.\""
    }
  }
];

